module.exports = __webpack_public_path__ + "img/c-10.34992fc6.jpg";